module.exports = __webpack_public_path__ + "4bd2310bac0c7a06efc672473237c62d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/neu/sozialhilfetabelle-neu.svg
// module id = 140
// module chunks = 1